import React, {PropTypes} from 'react'
import cx from 'classnames'

import { Details, Row, Block } from '../details/details'
import { Button } from '../buttons'
import { LightBlueBadge } from '../data-card/data-card-parts'
import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock
} from '../modal-form/modal-form'

import WorkSummaryWorkOrderTabsInProgressContainer from '../../containers/work-summaries/work-summary-work-order-tabs-in-progress-container'
import WorkSummaryWorkOrderTabsPendingApprovalContainer from '../../containers/work-summaries/work-summary-work-order-tabs-pending-approval-container'
import WorkSummaryWorkOrderTabsSignedOffContainer from '../../containers/work-summaries/work-summary-work-order-tabs-signed-off-container'

import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap.css'

import storage from 'local-storage-fallback'

const EMAIL_REGEXP = /(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*(;|,)\s*|\s*$))*/

export default class WorkSummaryWorkOrderDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showEmailModal: false,
      recipients: storage.getItem('email'),
      emailsSent: false,
      invalidEmail: false,
    }
    this.toggleEmailModal = this.toggleEmailModal.bind(this)
    this.onReceiptEmailSubmit = this.onReceiptEmailSubmit.bind(this)
    this.onChangeRecipients = this.onChangeRecipients.bind(this)
  }

  toggleEmailModal () {
    this.setState({ showEmailModal: !this.state.showEmailModal })
  }

  onReceiptEmailSubmit (e) {
    e.preventDefault()
    this.props.sendReceiptEmail(this.state.recipients)
      .then(() => {
        this.setState({ emailsSent: true })
        setTimeout(() => {
          this.setState({ emailsSent: false })
          this.toggleEmailModal()
        }, 2500)
      })
  }

  onChangeRecipients ({target: {value}}) {
    const [matched] = EMAIL_REGEXP.exec(value)
    this.setState({ recipients: value, invalidEmail: matched !== value })
  }

  render () {
    const {
      workOrder = {},
      locationModel,
      signedOff,
      userType,

      loading,
      approveRemaining,

      location,
      children,
      csvDownload
    } = this.props

    if (loading) {
      return <p>Loading...</p>
    }

    const workOrderId = workOrder.id ? workOrder.id.toString() : ''
    const canSendReceipt = signedOff && ['Administrator', 'AccountManager'].includes(userType)
    const secondaryActionCall = canSendReceipt ? [csvDownload, this.toggleEmailModal] : csvDownload

    const constraints = {
      'width': '706px',
      'minWidth': '706px'
    }

    return (
      <div>
        <Details
          secondaryActionType={canSendReceipt ? ['download', 'export'] : 'download'}
          secondaryActionCall={secondaryActionCall}
        >
          <Row>
            <Block title={locationModel && locationModel.name}>
              <p><LightBlueBadge text={workOrderId.toString() || ''} /></p>
            </Block>
            {formatStatus(workOrder)}
            {workOrder.status != 'in_progress' && formatSignOffStatus(workOrder, location)}
            {workOrder.status != 'in_progress' && formatBulkApproval(workOrder, approveRemaining)}
          </Row>
        </Details>

        {getTabs(workOrder, location)}
        {children}

        <BaseModal
          isOpen={this.state.showEmailModal}
          onClose={this.toggleEmailModal}
          title='Send Sign Off Receipt Email'
          constraints={constraints}
          contentClassName='areas-create-container'
        >
          <ModalForm onSubmit={this.onReceiptEmailSubmit}>
            <ModalFormRow>
              <ModalFormBlock>
                <p className={cx('centered', 'notice', { hidden: !this.state.emailsSent })} style={{ width: '200px' }}>
                  {this.state.recipients.split(',').length > 1 ? 'Emails' : 'Email'} sent!
                </p>
              </ModalFormBlock>
            </ModalFormRow>
            <ModalFormRow>
              <ModalFormBlock>
                <label>Recipient emails: <span style={{ color: 'red' }}>*</span></label>
                <input className={cx({invalid: this.state.invalidEmail})} type="text" id="recipients" name="recipients" value={this.state.recipients} onChange={this.onChangeRecipients}/>
              </ModalFormBlock>
            </ModalFormRow>
            <div style={{fontSize: '12px', fontStyle: 'italic', float: 'right'}}>Separate recipients with a semi-colon (;) in between emails <i>(e.g. john@gmail.com; mary@hotmail.com)</i>.</div>
            <ModalFormRow>
              <ModalFormBlock submitButton>
                <button type='submit' disabled={this.state.invalidEmail}>Send</button>
              </ModalFormBlock>
            </ModalFormRow>
          </ModalForm>   
        </BaseModal>
      </div>
    )
  }
}
function formatStatus (summarizable) {
  var action, attribute

  if (summarizable.status === 'in_progress') {
    action = 'First serviced'
    attribute = 'firstServicedAt'
  } else if (summarizable.status === 'pending_approval') {
    action = 'Submitted'
    attribute = 'completedAt'
  } else if (summarizable.status === 'signed_off') {
    action = 'Signed off at'
    attribute = 'signedOffAt'
  }

  if (summarizable[attribute]) {
    return (
      <Block title={action}>
        <p>{summarizable[attribute].format('MMMM D, YYYY – h:mmA')}</p>
      </Block>
    )
  } else {
    return null
  }
}

function formatSignOffStatus (workOrder, location) {
  if (workOrder.status === 'signed_off') {
    return (
      <Block title='signed by'>
        {workOrder.typedSignature}
      </Block>
    )
  } else {
    const disabled = !(workOrder.permissions || {}).canSignOff

    return (
      <Block title='signature'>
        <Tooltip
          overlay={<span>Please check all areas.</span>}
          placement='bottom'
          trigger={disabled ? ['hover'] : []}>
          <Button small
            disabled={disabled}
            to={`${location.pathname}/sign-off`}>
            Sign Off
          </Button>
        </Tooltip>
      </Block>
    )
  }
}

function formatBulkApproval (workOrder, approveRemaining) {
  if (workOrder.status !== 'pending_approval') {
    return null
  }

  const canApprove = workOrder.servicingsCounts && workOrder.servicingsCounts.approvable > 0
  const message = canApprove
    ? 'Approve all completed, unchecked areas.'
    : 'All completed areas have been checked.'

  return (
    <Block title='quick approval'>
      <Tooltip overlay={message} placement='bottom'>
        <Button small disabled={!canApprove} onClick={approveRemaining}>
          Check All
        </Button>
      </Tooltip>
    </Block>
  )
}

function getTabs (workOrder, location) {
  if (workOrder.status === 'in_progress') {
    return <WorkSummaryWorkOrderTabsInProgressContainer workOrderId={workOrder.id} location={location} />
  } else if (workOrder.status === 'pending_approval') {
    return <WorkSummaryWorkOrderTabsPendingApprovalContainer workOrderId={workOrder.id} location={location} />
  } else if (workOrder.status === 'signed_off') {
    return <WorkSummaryWorkOrderTabsSignedOffContainer workOrderId={workOrder.id} location={location} />
  }
}



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summary-work-order-details.js